<template>
    <div class="additional-services">
        <div class="inline small corner bg-default outline" :class="{shown: show}">
            <a v-if="!glb.rentals" class="flex middle" @click="toggle"><span>Additional services</span><i class="icon-angle-down"></i></a>
            <div id="cmasw"></div>
        </div>
    </div>
</template>

<script src="./additional-services.js"></script>

<!-- <style lang="scss">
    @use "./additional-services.scss" as *;
</style> -->
